export default __webpack_public_path__ + "img/trending_top.faae43d7.jpg";